import { selectIsRightBarVisible } from "@editor/selectors/ui";
import { useEditorSelector } from "@editor/store";

export default function useRightBarVisibility() {
  return useEditorSelector(selectIsRightBarVisible);
}
